/** Alphanumeric PNR-style confirmation (e.g. R28SSK); avoids I, O, 0, 1. */
const CONFIRMATION_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/** 13-digit-style e-ticket number for display (not an airline-issued document). */
export function generateConfirmationNumber(): string {
  let s = '';
  for (let i = 0; i < 6; i += 1) {
    s += CONFIRMATION_CHARS[Math.floor(Math.random() * CONFIRMATION_CHARS.length)]!;
  }
  return s;
}

export function generateEticketNumber(): string {
  let d = '';
  for (let i = 0; i < 13; i += 1) {
    d += String(Math.floor(Math.random() * 10));
  }
  return d;
}

/** Returns a normalized 13-digit e-ticket number or undefined when invalid. */
export function sanitizeEticketNumber(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const digits = value.replace(/\D/g, '');
  if (digits.length !== 13) return undefined;
  return digits;
}

/** Ensures a valid 13-digit numeric e-ticket number. */
export function ensureEticketNumber(value?: string): string {
  return sanitizeEticketNumber(value) ?? generateEticketNumber();
}
